import { createActions, createReducer } from 'reduxsauce'

import ConsultaBemService from '../servicos/ConsultaBemService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaSituacaoLegalInicio: [],
    buscaSituacaoLegalSucesso: ['situacaoLegal'],
    buscaSituacaoLegalErro: ['erro'],
    limpar: [],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaSituacaoLegal = filtro => {
    return dispatch => {
        dispatch(Creators.buscaSituacaoLegalInicio())
        let serv = new ConsultaBemService()
        return serv
            .todasSituacaoLegal()
            .then(response => dispatch(Creators.buscaSituacaoLegalSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaSituacaoLegalErro(error)))
    }
}

const buscaSituacaoLegalInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaSituacaoLegalErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaSituacaoLegalSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.situacaoLegal, carregando: false }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_SITUACAO_LEGAL_INICIO]: buscaSituacaoLegalInicio,
    [Types.BUSCA_SITUACAO_LEGAL_ERRO]: buscaSituacaoLegalErro,
    [Types.BUSCA_SITUACAO_LEGAL_SUCESSO]: buscaSituacaoLegalSucesso,
    [Types.LIMPAR]: limpar,
})
